<template>
    <b-container fluid>
        <b-row align-h="center">
            <b-col cols="12" sm="10" lg="5">

                <div class="div-section-header">
                    <b-row>
                        <b-col cols="12">
                            <div>
                            <span class="txt-section-title">Account Management</span>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <b-overlay :show=busy>
                    <b-card no-body v-if="student !== null">
                        <b-tabs content-class="mt-3" card>
                            <b-tab title="Home" active>
                                <template v-slot:title>
                                  <b-icon icon="house-fill"></b-icon>
                                </template>
                                <account-home v-model="student"></account-home>
                            </b-tab>
                            <b-tab title="Profile">
                                <template v-slot:title>
                                  <b-icon icon="person-fill"></b-icon>
                                </template>
                                <account-profile v-model="student"></account-profile>
                            </b-tab>
                            <b-tab title="Password">
                                <template v-slot:title>
                                  <b-icon icon="lock-fill"></b-icon>
                                </template>
                                <account-password v-model="student"></account-password>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-overlay>

            </b-col>
        </b-row>
    </b-container>
</template>

<script>
/* eslint-disable */

// Using v-model with custom components
// https://stackoverflow.com/questions/49072799/vuejs-how-to-pass-an-object-as-prop-and-have-the-component-update-sub-objects

import service from "@/service/service"

import AccountHome from '@/components/AccountHome'
import AccountProfile from '@/components/AccountProfile'
import AccountPassword from '@/components/AccountPassword'

// v-model with custom components

export default {
  name: "Account",
  data() {
    return {
        msg: "",
        show: true,
        debug: false,
        loading: false,
        busy: false,
        error: false,
        studentHash: null,
        student: null
    }
  },
  components: {
    'account-home': AccountHome,
    'account-profile': AccountProfile,
    'account-password': AccountPassword
  },
  methods: { },
  created() {
    this.studentHash = this.$root.getToken()
    if (this.studentHash.length !== 0) {
      this.busy = true
      service
        .getProfile(this.studentHash)
        .then(
          (res => {
            if (this.debug) console.log(`back from getProfile!`);
            if (this.debug) console.log(res);
            if (res.status) {
                this.student = res.student
            }
            else {
              this.error = true
            }
          }).bind(this)
        )
        .finally(e => {
          this.busy = false
        })
        .catch(e => {
          this.error = true
          console.log(e)
        })
    }
    else {
        // flag error!
        console.log(`Missing student hash.`)
    }
  },
  mounted() {
    if (this.debug) console.log('mounted')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account.vue